import CustomButton from "components/Atoms/CustomButton"
import CustomDialog, { CustomDialogProps } from "components/Atoms/CustomDialog"
import Toggle from "components/Atoms/Toggle"
import { useUpdateBulkDemandsMutation } from "generated/graphql"
import { get } from "lodash-es"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { ApplicationState } from "store"
import { RESET_SELECTED } from "store/selector.redux"
import AppToaster from "utils/AppToaster"
export interface StatusDialogProps extends CustomDialogProps {
  demands: (string | null)[]
  totalDemands?: number
}

const StatusDialog = ({
  isOpen,
  totalDemands,
  onClose,
  demands,
}: StatusDialogProps) => {
  const [isLive, setLive] = useState(false)
  const filter = useSelector<ApplicationState, any>(
    state => state.demands.filter
  )

  const dispatch = useDispatch()

  const [updateBulkDemands, { loading }] = useUpdateBulkDemandsMutation({
    onCompleted(data) {
      const demands = data.updateBulkDemands?.demands
      AppToaster.show({
        message: (
          <span>
            Statuses of{" "}
            <span className="vt-highlight"> {demands?.length ?? 0}</span>{" "}
            demands updated successfully!
          </span>
        ),
        intent: "success",
        icon: "tick",
      })
      dispatch({
        type: RESET_SELECTED,
        path: "demands",
      })
      onClose?.(null)
    },
    onError(err) {
      AppToaster.show({
        message: "Unable to update status",
        intent: "danger",
        icon: "cross",
      })
    },
  })
  const liveStatus = filter?.isLive
  const isLiveChecked =
    liveStatus === "live" ? true : liveStatus === "not-live" ? false : null
  const parsedFilter = {
    date_Gte: get(filter, "demandRange.0", null),
    date_Lte: get(filter, "demandRange.1", null),
    variety_Id: get(filter, "variety.id", null),
    depot_Id: get(filter, "depot.id", null),
    isLive: isLiveChecked,
  }
  return (
    <CustomDialog
      light
      icon="offline"
      title="Change Status"
      isOpen={isOpen}
      onClose={onClose}
      footerRightButton={
        <CustomButton
          loading={loading}
          icon="saved"
          text="Update Status"
          dark
          onClick={e => {
            updateBulkDemands({
              variables: {
                filter:
                  Object.values(parsedFilter).some(v => v) &&
                  demands?.length === 0
                    ? parsedFilter
                    : null,
                query: demands?.length > 0 ? null : filter?.search,
                ids:
                  Object.values(parsedFilter).some(v => v) || filter?.search
                    ? null
                    : demands,
                isLive,
              },
            })
          }}
        />
      }
    >
      <section className="flex justify-center flex-col items-center text-center">
        <span className="text-lg">
          Change status for{" "}
          <span className="vt-highlight">
            {demands?.length || totalDemands}
          </span>{" "}
          demands ?
        </span>
        <Toggle
          checked={isLive ? true : false}
          onChange={e => setLive(prev => !prev)}
          className="mt-3"
          large
          label={isLive ? "Live" : "Not Live"}
        />
      </section>
    </CustomDialog>
  )
}

export default StatusDialog
